import {
    ADDORUPDATEENTITYTYPELIST_SUCCESS,
    ADDORUPDATEENTITYTYPELIST_FAILED,
    RESET_ADDORUPDATEENTITYTYPELIST,
    LOADING_ADDORUPDATEENTITYTYPELIST,
    NETWORK_ERROR_ADDORUPDATEENTITYTYPELIST,
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {},
    message: "",
    networkError: "",
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_ADDORUPDATEENTITYTYPELIST:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {},
                message: "",
                networkError: "",
            };
        case ADDORUPDATEENTITYTYPELIST_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload,
                message: "",
                networkError: "",
            };
        case ADDORUPDATEENTITYTYPELIST_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload,
                message: "",
                networkError: "",
            };
        case NETWORK_ERROR_ADDORUPDATEENTITYTYPELIST:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {},
                message: "",
                networkError: "",
            };
        case RESET_ADDORUPDATEENTITYTYPELIST:
            return (state = initialState);
        default:
            return state;
    }
};
